import "semantic-ui-css/semantic.min.css";
import "./App.css";
import "./index.css";
import ContainerComp from "./components/frames/ContainerComp";
import { BrowserRouter } from "react-router-dom";

import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import {
  ListUser,
  ListInvoice,
  ListRecivedMoney,
  ListSpendMoney,
  CreateCompany,
  ListCompany,
  AddExpense,
  ListExpanse,
  NewInvoice,
  SpendMoney,
  ReciveMoney,
  DailyWorkList,
  CreateNewWork,
  Login,
  Dashboard,
  CreateEmp,
  ListEmp,
  ExpiryDoc,
  ListInvoiceTwo,
  PdfFileNewFormet,
  CompanyList,
  WorkListArr,
  DailyWorkCatogery,
  CatogeryList,
  WorkListNewFormat,
  ListCompanyNew,
  UpdateCompanyForm,
  NewCompanyForm,
  ListCompany2,
  NewFormetCompanyForm,
  VisaCreation,
  VisaList,
  VisaCatogeryList,
  CreateVisaCatogery,
  VisaListWithCat,
  CreatePurchase,
  CreatePurchaseCat,
  PurchaseCatList,
  PurchaseListWithCat,
  PurchaseList,
  CreateCategoryAll,
  CategoryListAll,
  ReciveCategoryListAll,
  ReciveCreateCategory,
  SpendCategoryListAll,
  SpendCreateCategory,
  CompanyCategoryList,
  CompanyCreateCategory,
  CreateTour,
  CreateVehile,
  ToursList,
  VehileList,
  ContactCatList,
  ContactCatogery,
  ContactList,
  ContactCreate,
  ComapnyEmpCreate,
  CompanyEmpCatList,
  CompanyEmpList,
  CompanyEmpCatogery,
  CreateCusVisaCatogery,
  CusVisaCatogeryList,
  CusVisaList,
  CusVisaListWithCat,
  CusVisaCreation,
  InvoiceCategoryListAll,
  InvoiceCreateCategory,
  InvoiceItemList,
  InvoiceItemCreate,
  InvoiceWorknameList,
  InvoiceWorknameCreate,
  DailyworkForList,
  DailyWorkForCreate,
  DailyworkPdf,
  CreateTicketInventoryCatogery,
  CreateTicketInventoryCatogerytwo,
  TicketCatogeryList,
  TicketCatogeryListtwo,
  TicketDataListwithCat,
  TicketDataListwithCattwo,
  TicketList,
  TicketListtwo,
  CreateTicketLiatData,
  CreateTicketLiatDatatwo,
  TicketTypeList,
  TicketTypeListtwo,
  CreateTicketType,
  CreateTicketTypetwo,
  TourPackageList,
  CreateTourPackage,
  TravelPackCaregoryCreateNew,
  TravelPackListNew,
  TravelPackCategoryListnew,
  TravelPackListWithCatNew,
  TravelPackCreateNew,
  TravelPackHotelList,
  TravelPackHotelCreate,
  TravelPackItemList,
  TravelPackItemCreate,
  TourInvoicepdf,
  DataInvCreate,
  DataInvList,
  DataInvCatogery,
  DataInvCatogeryList,
  DataInvListWithCat,
  DataInvIndiaCatogeryList,
  DataInvIndiaCatogery,
  DataInvListIndiaWithCat,
  DataInvIndiaCreate,
  InvoiceCategoryListIndia,
  InvoiceCategoryCreateIndia,
  InvoiceWorkNameIndiaList,
  InvoiceWorkNameIndiaCreate,
  InvoiceItemIndiaList,
  InvoiceItemCreateIndia,
  ListInvoiceWithCatIndia,
  ListInvoiceIndia,
  NewInvoiceIndia,
  DeCompanyCreate,
  DeCompanyList,
  DeRecivedBankCreate,
  DeRecivedBankList,
  DeTicketTypeCreate,
  DeTicketTypeList,
  DeDailyEntryCreate,
  DeDailyEntryDataList,
  DeListCatogery,
  DeCattogeryCreate,
  DeListWithCatogery
} from "./components/pages";
function App() {
  const [isLoggedIn, setisLoggedIn] = useState(false);
  useEffect(() => {
    const authToken = Cookies.get("authToken");
    if (authToken) {
      setisLoggedIn(true);
    } else {
    }
  }, [isLoggedIn]);
  const roles = {
    admin: ["admin"],
    user: ["user"],
  };
  const RoleRoute = ({ component: Component, roles, ...rest }) => {
    const userRole = "admin";
    const authToken = Cookies.get("authTokens");

    // console.log("ajbaibaixbax", authToken);
    const userType = "admin";

    if (!authToken) {
      return <Navigate to="/login" />;
    }

    if (!roles.includes(userType)) {
      return <Navigate to="/forbidden-error" />;
    }
    if (authToken) {
      return <Component {...rest} />;
    }
  };
  return (
    <BrowserRouter>
      {/* <ContainerComp /> */}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          exact
          path="/"
          element={<RoleRoute component={ContainerComp} roles={roles.admin} />}
        >
          <Route
            path="/dashboard"
            element={<RoleRoute component={ExpiryDoc} roles={roles.admin} />}
          />

          <Route
            path="/list-contact-catogery"
            element={
              <RoleRoute component={ContactCatList} roles={roles.admin} />
            }
          />
          <Route
            path="/list-contact-details/:catId"
            element={<RoleRoute component={ContactList} roles={roles.admin} />}
          />
          <Route
            path="/create-contact-category/:id/:catId"
            element={
              <RoleRoute component={ContactCatogery} roles={roles.admin} />
            }
          />
          <Route
            path="/create-contact-detail/:id/:catId"
            element={
              <RoleRoute component={ContactCreate} roles={roles.admin} />
            }
          />
          {/* lscnoisncisnicnsinc */}
          <Route
            path="/list-company-emp-catogery"
            element={
              <RoleRoute component={CompanyEmpCatList} roles={roles.admin} />
            }
          />
          <Route
            path="/list-company-employee/:catId"
            element={
              <RoleRoute component={CompanyEmpList} roles={roles.admin} />
            }
          />
          <Route
            path="/create-company-emp-category/:id/:catId"
            element={
              <RoleRoute component={CompanyEmpCatogery} roles={roles.admin} />
            }
          />
          <Route
            path="/create-company-employee/:id/:catId"
            element={
              <RoleRoute component={ComapnyEmpCreate} roles={roles.admin} />
            }
          />

          <Route
            path="/list-company-newFormet"
            element={<RoleRoute component={ListCompany2} roles={roles.admin} />}
          />

          <Route
            path="/list-invoice-india-catogery"
            element={
              <RoleRoute
                component={InvoiceCategoryListIndia}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/list-invoice-catogery"
            element={
              <RoleRoute
                component={InvoiceCategoryListAll}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/list-invoice-workname"
            element={
              <RoleRoute component={InvoiceWorknameList} roles={roles.admin} />
            }
          />

          <Route
            path="/list-invoice-india-workname"
            element={
              <RoleRoute
                component={InvoiceWorkNameIndiaList}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/list-dailywork-forname"
            element={
              <RoleRoute component={DailyworkForList} roles={roles.admin} />
            }
          />

          <Route
            path="/create-invoice-category/:id/:catId"
            element={
              <RoleRoute
                component={InvoiceCreateCategory}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/create-invoice-india-category/:id/:catId"
            element={
              <RoleRoute
                component={InvoiceCategoryCreateIndia}
                roles={roles.admin}
              />
            }
          />
          <Route
            path="/list-invoice-item"
            element={
              <RoleRoute component={InvoiceItemList} roles={roles.admin} />
            }
          />

          <Route
            path="/list-invoice-india-item"
            element={
              <RoleRoute component={InvoiceItemIndiaList} roles={roles.admin} />
            }
          />
          <Route
            path="/create-invoice-items/:id/:catId"
            element={
              <RoleRoute component={InvoiceItemCreate} roles={roles.admin} />
            }
          />

          <Route
            path="/create-invoice-inda-items/:id/:catId"
            element={
              <RoleRoute
                component={InvoiceItemCreateIndia}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/create-invoice-workname/:id/:catId"
            element={
              <RoleRoute
                component={InvoiceWorknameCreate}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/create-invoice-india-workname/:id/:catId"
            element={
              <RoleRoute
                component={InvoiceWorkNameIndiaCreate}
                roles={roles.admin}
              />
            }
          />
          <Route
            path="/create-dailywork-forname/:id/:catId"
            element={
              <RoleRoute component={DailyWorkForCreate} roles={roles.admin} />
            }
          />
          <Route
            path="/recive-money-catogery"
            element={
              <RoleRoute
                component={ReciveCategoryListAll}
                roles={roles.admin}
              />
            }
          />
          <Route
            path="/create-recive-money-category/:id/:catId"
            element={
              <RoleRoute component={ReciveCreateCategory} roles={roles.admin} />
            }
          />

          <Route
            path="/spend-money-catogery"
            element={
              <RoleRoute component={SpendCategoryListAll} roles={roles.admin} />
            }
          />
          <Route
            path="/create-spend-money-category/:id/:catId"
            element={
              <RoleRoute component={SpendCreateCategory} roles={roles.admin} />
            }
          />

          <Route
            path="/new-company-catogery"
            element={
              <RoleRoute component={CompanyCategoryList} roles={roles.admin} />
            }
          />
          <Route
            path="/create-new-company-category/:id/:catId"
            element={
              <RoleRoute
                component={CompanyCreateCategory}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/create-company-newFormet/:id/:catid"
            element={
              <RoleRoute component={NewFormetCompanyForm} roles={roles.admin} />
            }
          />
          <Route
            path="/create-employee/:id"
            element={<RoleRoute component={CreateEmp} roles={roles.admin} />}
          />
          <Route
            path="/list-employee"
            element={<RoleRoute component={ListEmp} roles={roles.admin} />}
          />

          <Route
            path="/create-company/:urlId/:id"
            element={
              <RoleRoute component={CreateCompany} roles={roles.admin} />
            }
          />
          <Route
            path="/create-company-new/:urlId/:id"
            element={
              <RoleRoute component={UpdateCompanyForm} roles={roles.admin} />
            }
          />
          {/* <Route
            path="/create-company-new/:urlId/:id"
            element={
              <RoleRoute component={UpdateCompanyForm} roles={roles.admin} />
            }
          /> */}
          <Route
            path="/create-company-new"
            element={
              <RoleRoute component={ListCompanyNew} roles={roles.admin} />
            }
          />
          <Route
            path="/list-user"
            element={<RoleRoute component={ListUser} roles={roles.admin} />}
          />
          <Route
            path="/company-list"
            element={<RoleRoute component={ListCompany} roles={roles.admin} />}
          />
          <Route
            path="/new-invoice/:id/:catid"
            element={<RoleRoute component={NewInvoice} roles={roles.admin} />}
          />

          <Route
            path="/new-india-invoice/:id/:catid"
            element={
              <RoleRoute component={NewInvoiceIndia} roles={roles.admin} />
            }
          />
          <Route
            path="/recive-money/:id/:catid"
            element={<RoleRoute component={ReciveMoney} roles={roles.admin} />}
          />
          <Route
            path="/spend-money/:id/:catid"
            element={<RoleRoute component={SpendMoney} roles={roles.admin} />}
          />
          <Route
            path="/list-invoice/:catId"
            element={
              <RoleRoute component={ListInvoiceTwo} roles={roles.admin} />
            }
          />

          <Route
            path="/list-india-invoice/:catId"
            element={
              <RoleRoute component={ListInvoiceIndia} roles={roles.admin} />
            }
          />
          <Route
            path="/list-sample-invoice"
            element={
              <RoleRoute component={ListInvoiceTwo} roles={roles.admin} />
            }
          />
          <Route
            path="/list-recive-money/:catId"
            element={
              <RoleRoute component={ListRecivedMoney} roles={roles.admin} />
            }
          />
          <Route
            path="/list-spend-money/:catId"
            element={
              <RoleRoute component={ListSpendMoney} roles={roles.admin} />
            }
          />
          {/* DailyWorkList WorkListArr*/}
          <Route
            path="/daily-work-list/:catId"
            element={
              <RoleRoute component={WorkListNewFormat} roles={roles.admin} />
            }
          />
          <Route
            path="/create-new-work/:id/:catId"
            element={
              <RoleRoute component={CreateNewWork} roles={roles.admin} />
            }
          />
          <Route
            path="/expiry-details"
            element={<RoleRoute component={ExpiryDoc} roles={roles.admin} />}
          />
          <Route
            path="/daily-work-category"
            element={<RoleRoute component={CatogeryList} roles={roles.admin} />}
          />

          <Route
            path="/create-new-workcategory/:id"
            element={
              <RoleRoute component={DailyWorkCatogery} roles={roles.admin} />
            }
          />

          <Route
            path="/list-visa-all/:catId"
            element={
              <RoleRoute component={VisaListWithCat} roles={roles.admin} />
            }
          />
          <Route
            path="/new-visa-create/:id/:catid"
            element={<RoleRoute component={VisaCreation} roles={roles.admin} />}
          />
          <Route
            path="/list-visa-category"
            element={
              <RoleRoute component={VisaCatogeryList} roles={roles.admin} />
            }
          />
          <Route
            path="/create-visa-category/:id"
            element={
              <RoleRoute component={CreateVisaCatogery} roles={roles.admin} />
            }
          />

          <Route
            path="/list-cus-visa-all/:catId"
            element={
              <RoleRoute component={CusVisaListWithCat} roles={roles.admin} />
            }
          />
          <Route
            path="/new-cus-visa-create/:id/:catid"
            element={
              <RoleRoute component={CusVisaCreation} roles={roles.admin} />
            }
          />
          <Route
            path="/list-cus-visa-category"
            element={
              <RoleRoute component={CusVisaCatogeryList} roles={roles.admin} />
            }
          />
          <Route
            path="/create-cus-visa-category/:id"
            element={
              <RoleRoute
                component={CreateCusVisaCatogery}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/purchase-category-list"
            element={
              <RoleRoute component={PurchaseCatList} roles={roles.admin} />
            }
          />
          <Route
            path="/create-purchase-category/:id"
            element={
              <RoleRoute component={CreatePurchaseCat} roles={roles.admin} />
            }
          />
          <Route
            path="/purchase-list/:catId"
            element={
              <RoleRoute component={PurchaseListWithCat} roles={roles.admin} />
            }
          />
          <Route
            path="/create-purchase/:id/:catid"
            element={
              <RoleRoute component={CreatePurchase} roles={roles.admin} />
            }
          />
          <Route
            path="/create-new-tour/:id"
            element={<RoleRoute component={CreateTour} roles={roles.admin} />}
          />
          <Route
            path="/create-new-vehicle/:id"
            element={<RoleRoute component={CreateVehile} roles={roles.admin} />}
          />
          <Route
            path="/tour-list"
            element={<RoleRoute component={ToursList} roles={roles.admin} />}
          />
          <Route
            path="/vehile-list"
            element={<RoleRoute component={VehileList} roles={roles.admin} />}
          />

          <Route
            path="/attractopn-caregory-list/:id"
            element={
              <RoleRoute component={TicketCatogeryList} roles={roles.admin} />
            }
          />

<Route
            path="/attractopn-caregory-list-two/:id"
            element={
              <RoleRoute component={TicketCatogeryListtwo} roles={roles.admin} />
            }
          />
          <Route
            path="/create-ticket-type-category/:id"
            element={
              <RoleRoute
                component={CreateTicketInventoryCatogery}
                roles={roles.admin}
              />
            }
          />
           <Route
            path="/create-ticket-type-category-two/:id"
            element={
              <RoleRoute
                component={CreateTicketInventoryCatogerytwo}
                roles={roles.admin}
              />
            }
          />
          <Route
            path="/list-ticket-data-all/:catId"
            element={
              <RoleRoute
                component={TicketDataListwithCat}
                roles={roles.admin}
              />
            }
          />
           <Route
            path="/list-ticket-data-all-two/:catId"
            element={
              <RoleRoute
                component={TicketDataListwithCattwo}
                roles={roles.admin}
              />
            }
          />
          <Route
            path="/new-ticket-data/:id/:catId"
            element={
              <RoleRoute component={CreateTicketLiatData} roles={roles.admin} />
            }
          />
             <Route
            path="/new-ticket-data-two/:id/:catId"
            element={
              <RoleRoute component={CreateTicketLiatDatatwo} roles={roles.admin} />
            }
          />

          <Route
            path="/tickettype-caregory-list/:id"
            element={
              <RoleRoute component={TicketTypeList} roles={roles.admin} />
            }
          />
            <Route
            path="/tickettype-caregory-list-two/:id"
            element={
              <RoleRoute component={TicketTypeListtwo} roles={roles.admin} />
            }
          />
          <Route
            path="/create-ticket-type/:id"
            element={
              <RoleRoute component={CreateTicketType} roles={roles.admin} />
            }
          />

<Route
            path="/create-ticket-type-two/:id"
            element={
              <RoleRoute component={CreateTicketTypetwo} roles={roles.admin} />
            }
          />
          {/* <Route
            path="/create-ticket-type/:id"
            element={
              <RoleRoute
                component={CreateTicketType}
                roles={roles.admin}
              />
            }
          /> <Route
          path="/tour-package-inoice-list/:id"
          element={
            <RoleRoute
              component={TourPackageList}
              roles={roles.admin}
            />
          }
        /> */}
          {/* <Route
          path="/create-tour-package-new/:id/:catId"
          element={
            <RoleRoute
              component={CreateTourPackage}
              roles={roles.admin}
            />
          }
        /> */}
          <Route
            path="/create-tour-package-new/:id/:catId"
            element={
              <RoleRoute component={TravelPackCreateNew} roles={roles.admin} />
            }
          />
          <Route
            path="/tour-package-category-list-new"
            element={
              <RoleRoute
                component={TravelPackCategoryListnew}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/create-tour-package-hotel-new/:id/:catId"
            element={
              <RoleRoute
                component={TravelPackHotelCreate}
                roles={roles.admin}
              />
            }
          />
          <Route
            path="/tour-package-hotel-list-new"
            element={
              <RoleRoute component={TravelPackHotelList} roles={roles.admin} />
            }
          />

          <Route
            path="/create-tour-package-item-new/:id/:catId"
            element={
              <RoleRoute component={TravelPackItemCreate} roles={roles.admin} />
            }
          />
          <Route
            path="/tour-package-items-list-new"
            element={
              <RoleRoute component={TravelPackItemList} roles={roles.admin} />
            }
          />

          {/*  TravelPackItemList,
  TravelPackItemCreate */}
          <Route
            path="/tour-package-list-new/:catId"
            element={
              <RoleRoute component={TravelPackListNew} roles={roles.admin} />
            }
          />
          <Route
            path="/create-tour-package-category-new/:id/:catId"
            element={
              <RoleRoute
                component={TravelPackCaregoryCreateNew}
                roles={roles.admin}
              />
            }
          />
          <Route
            path="/data-inv-catogery-list"
            element={
              <RoleRoute component={DataInvCatogeryList} roles={roles.admin} />
            }
          />

          <Route
            path="/data-inv-catogery-india-list"
            element={
              <RoleRoute
                component={DataInvIndiaCatogeryList}
                roles={roles.admin}
              />
            }
          />
          <Route
            path="/data-inv-catogery-create/:id"
            element={
              <RoleRoute component={DataInvCatogery} roles={roles.admin} />
            }
          />

          <Route
            path="/data-inv-catogery-india-create/:id"
            element={
              <RoleRoute component={DataInvIndiaCatogery} roles={roles.admin} />
            }
          />

          <Route
            path="/data-inv-new-list/:catId"
            element={
              <RoleRoute component={DataInvListWithCat} roles={roles.admin} />
            }
          />

          <Route
            path="/data-inv-new-india-list/:catId"
            element={
              <RoleRoute
                component={DataInvListIndiaWithCat}
                roles={roles.admin}
              />
            }
          />

          <Route
            path="/data-inv-new-create/:id/:catId"
            element={
              <RoleRoute component={DataInvCreate} roles={roles.admin} />
            }
          />

          <Route
            path="/data-inv-india-new-create/:id/:catId"
            element={
              <RoleRoute component={DataInvIndiaCreate} roles={roles.admin} />
            }
          />

          <Route
            path="/data-inv-newind-list/:catId"
            element={
              <RoleRoute component={DataInvListWithCat} roles={roles.admin} />
            }
          />

          <Route
            path="/data-inv-newind-create/:id/:catId"
            element={
              <RoleRoute component={DataInvCreate} roles={roles.admin} />
            }
          />

          <Route
            path="/daily-entry-company-list"
            element={
              <RoleRoute component={DeCompanyList} roles={roles.admin} />
            }
          />
          <Route
            path="/daily-entry-company-create/:id"
            element={
              <RoleRoute component={DeCompanyCreate} roles={roles.admin} />
            }
          />

          <Route
            path="/daily-entry-ticket-type-list"
            element={
              <RoleRoute component={DeTicketTypeList} roles={roles.admin} />
            }
          />
          <Route
            path="/daily-entry-ticket-type-create/:id"
            element={
              <RoleRoute component={DeTicketTypeCreate} roles={roles.admin} />
            }
          />

          <Route
            path="/daily-entry-recived-bank-list"
            element={
              <RoleRoute component={DeRecivedBankList} roles={roles.admin} />
            }
          />
          <Route
            path="/daily-entry-recived-bank-create/:id"
            element={
              <RoleRoute component={DeRecivedBankCreate} roles={roles.admin} />
            }
          />

          <Route  //    DeDailyEntryDataList
            path="/daily-entry-data-list"
            element={
              <RoleRoute component={DeListWithCatogery} roles={roles.admin} />
            }
          />
          <Route
            path="/daily-entry-data-create/:id/:catId"
            element={
              <RoleRoute component={DeDailyEntryCreate} roles={roles.admin} />
            }
          />

<Route
            path="/daily-entry-catogery-list"
            element={
              <RoleRoute component={DeListCatogery} roles={roles.admin} />
            }
          />

<Route
            path="/create-daily-entry-catogery/:id/:catId"
            element={
              <RoleRoute component={DeCattogeryCreate} roles={roles.admin} />
            }
          />

        </Route>
        <Route path="/export-invoice" element={<PdfFileNewFormet />} />

        <Route path="/export-tour-invoice/:id" element={<TourInvoicepdf />} />

        <Route
          path="/export-dailywork-invoice/:id"
          element={<DailyworkPdf />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

// <Routes>
// <Route
//   path="/create-company/:urlId/:id"
//   element={<CreateCompany />}
// />

// <Route path="/list-user" element={<ListUser />} />

// <Route path="/new-invoice" element={<NewInvoice />} />
// <Route path="/recive-money" element={<ReciveMoney />} />
// <Route path="/spend-money" element={<SpendMoney />} />
// <Route path="/list-invoice" element={<ListInvoice />} />
// <Route path="/list-recive-money" element={<ListRecivedMoney />} />
// <Route path="/list-spend-money" element={<ListSpendMoney />} />
// <Route path="/daily-work-list" element={<DailyWorkList />} />
// <Route path="/create-new-work" element={<CreateNewWork />} />
// </Routes>
